<template>
  <v-container fluid class="plantillas-vista pa-3" :class="{ 'plantillas-vista--fija': ajustada }" :style="estiloAlto">
    <div class="plantillas-vista__escuela">
      <span class="plantillas-vista__label mr-2">Escuela</span>
      <v-btn
        small
        depressed
        :color="escuela === 1 ? '#00A548' : undefined"
        :dark="escuela === 1"
        :outlined="escuela !== 1"
        class="mr-1"
        @click="escuela = 1"
      >INBI</v-btn>
      <v-btn
        small
        depressed
        :color="escuela === 2 ? '#00A548' : undefined"
        :dark="escuela === 2"
        :outlined="escuela !== 2"
        @click="escuela = 2"
      >FAST</v-btn>
    </div>
    <div class="plantillas-vista__cuerpo">
      <PlantillasCatalogo :key="'escuela-' + escuela" :escuela="escuela" standalone @cambio="version++" />
      <PlantillasCalendario :key="'calendario-' + escuela" :escuela="escuela" :version="version" />
    </div>
  </v-container>
</template>

<script>
  import PlantillasCatalogo from '@/components/whatsapp/PlantillasCatalogo.vue'
  import PlantillasCalendario from '@/components/whatsapp/PlantillasCalendario.vue'

  export default {
    name: 'PlantillasWhatsApp',

    components: { PlantillasCatalogo, PlantillasCalendario },

    data: () => ({
      escuela: 1,
      version: 0,
    }),

    computed: {
      // En escritorio la vista ocupa justo el alto disponible y cada panel hace scroll por dentro.
      ajustada () {
        return this.$vuetify.breakpoint.mdAndUp
      },

      estiloAlto () {
        if (!this.ajustada) return {}
        const app = this.$vuetify.application
        const ocupado = app.top + app.bar + app.footer + app.insetFooter + app.bottom
        return { height: `calc(100vh - ${ocupado}px)` }
      },
    },

    watch: {
      ajustada: {
        immediate: true,
        handler (fija) {
          // Vuetify deja html con overflow-y: scroll; aquí no hay nada que desplazar en la página.
          document.documentElement.style.overflowY = fija ? 'hidden' : ''
        },
      },
    },

    beforeDestroy () {
      document.documentElement.style.overflowY = ''
    },
  }
</script>

<style scoped>
  .plantillas-vista {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .plantillas-vista__escuela {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .plantillas-vista__label {
    font-size: 13px;
    font-weight: 600;
    color: #3b4a54;
  }

  .plantillas-vista__cuerpo {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }

  .plantillas-vista--fija .plantillas-vista__cuerpo {
    flex: 1 1 auto;
    min-height: 0;
    grid-template-columns: minmax(0, 1fr) minmax(300px, 340px);
    grid-template-rows: minmax(0, 1fr);
  }
</style>
